import api from './api';
import { OrderResponse, SingleOrderResponse, OrderStatus, OrderPaymentStatus, OrderStatusLogsResponse, GoFrugalSyncStatus } from '../types/order';

export const getOrders = async (params?: {
    page?: number;
    limit?: number;
    search?: string;
    orderStatus?: OrderStatus;
    paymentStatus?: OrderPaymentStatus;
    goFrugalSyncStatus?: GoFrugalSyncStatus;
}): Promise<OrderResponse> => {
    const response = await api.get('/orders', { params });
    return response.data;
};

export const getOrderById = async (id: string): Promise<SingleOrderResponse> => {
    const response = await api.get(`/orders/${id}`);
    return response.data;
};

export const updateOrderStatus = async (id: string, payload: {
    orderStatus?: OrderStatus;
    paymentStatus?: OrderPaymentStatus;
    cancelReason?: string;
}): Promise<SingleOrderResponse> => {
    const response = await api.put(`/orders/${id}/status`, payload);
    return response.data;
};

export const getUnassignedOrders = async (params?: {
    page?: number;
    limit?: number;
    search?: string;
}): Promise<OrderResponse> => {
    const response = await api.get('/orders/unassigned', { params });
    return response.data;
};

export const getAssignedOrders = async (params?: {
    page?: number;
    limit?: number;
    search?: string;
}): Promise<OrderResponse> => {
    const response = await api.get('/orders/assigned', { params });
    return response.data;
};

export const assignOrder = async (orderId: string, deliveryBoyId: string): Promise<SingleOrderResponse> => {
    const response = await api.post(`/orders/${orderId}/assign`, { id: deliveryBoyId });
    return response.data;
};

export const reassignOrder = async (orderId: string, deliveryBoyId: string): Promise<SingleOrderResponse> => {
    const response = await api.put(`/orders/${orderId}/reassign`, { id: deliveryBoyId });
    return response.data;
};

export const getOrderStatusLogs = async (orderId: string): Promise<OrderStatusLogsResponse> => {
    const response = await api.get(`/orders/${orderId}/status-logs`);
    return response.data;
};

export const generateInvoice = async (orderId: string): Promise<{ success: boolean; data: { invoiceUrl: string } }> => {
    const response = await api.get(`/orders/${orderId}/invoice`);
    return response.data;
};

export interface GoFrugalSyncProgress {
    total: number;
    processed: number;
    synced: number;
    failed: number;
}

export interface GoFrugalSyncState {
    isRunning: boolean;
    startedAt?: string;
    finishedAt?: string;
    progress?: GoFrugalSyncProgress;
    lastError?: string;
}

export const syncOrdersToGoFrugal = async (): Promise<{ success: boolean; data: GoFrugalSyncState; message: string }> => {
    const response = await api.post('/orders/sync-to-gofrugal', {});
    return response.data;
};

export const getOrdersGoFrugalSyncStatus = async (): Promise<{ success: boolean; data: GoFrugalSyncState }> => {
    const response = await api.get('/orders/sync-to-gofrugal/status');
    return response.data;
};
